import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import useFileHandleS3 from "../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";

const SouvenirEditStar = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [viewSouviner, setViewSouviner] = useState({});
  const [description, setDescription] = useState();
  const [instruction, setInstruction] = useState();
  const [title, setTitle] = useState();
  const [price, setPrice] = useState();
  const [tax, setTax] = useState();
  // const [banner, setBanner] = useState();
  // const [video, setVideo] = useState();
  const [errorList, setError] = useState([]);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'marketplace/images',delKey);

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }


  useEffect(() => {
    // setDescription("");
    //   setInstruction("");
    //   setTitle("");
    //   setPrice("");
    //   setBanner("");
    //   setVideo("");

    axios.get(`/api/star/souviner/edit/${id}`).then((res) => {
      if (res.data.status === 200) {
        setDescription(res.data.getSouviner?.description);
        setInstruction(res.data.getSouviner?.instruction);
        setTitle(res.data.getSouviner?.title);
        setPrice(res.data.getSouviner?.price);
        setTax(res.data.getSouviner?.tax);
        setViewSouviner(res.data?.getSouviner);
        setFilePath(res.data.getSouviner?.banner)
      }
    });
  }, []);

  const actionSouviner = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("description", description);
    formData.append("instruction", instruction);
    formData.append("title", title);

    formData.append("price", price);
    formData.append("tax", tax);
    formData.append("banner", fileKey?fileKey:filePath);
    // formData.append("video", video);

    axios.post(`/api/star/souviner/update/${id}`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        if(file){
          setFile('');
          setDelKey(filePath.split("com/").pop())
        }

        setDescription("");
        setInstruction("");
        setTitle("");
        setPrice("");
        setTax("");
        // setVideo("");

        setError([]);
        swal("Welcome", res.data.message, "success");

        history.push("/superstar/souvenir");
      } else {
        setError(res.data.validation_errors);

        // error_list: res.data.validation_errors,
      }
    });
  };

  return (
    <>
      <div className="text-light d-flex border border-warning rounded-3 align-items-center justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit default Souvenir</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form id="input_form" onSubmit={actionSouviner}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Title</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control  text-light reply-control"
                        type="text"
                        name="title"
                        value={title}
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.title}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={description}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setDescription(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Instruction</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={instruction}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Banner</>
                      </p>
                    </div>
                    <div className="col-md-4">
                      {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleImageChange(e.target.files)}
                        ref={fileInputRef}
                      />
                       {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}

                      <span className="text-danger buTon-abc">
                        {errorList.banner}
                      </span>
                      {/* <label for="file">
                <i className="fas fa-cloud-upload-alt"></i> Upload Banner
              </label> */}
                    </div>
                  </div>

                  {/* <div className="row my-4 ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Video</>
                      </p>
                    </div>
                    <div className="col-md-4">
                      <ReactPlayer
                        url={
                          viewSouviner?.video
                            ? serverUrl + viewSouviner?.video
                            : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                        }
                        width="300px"
                        height="200px"
                        playing={false}
                        volume={1}
                        controls={true}
                        autoPlay
                      />
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(event) => {
                          setVideo(event.target.files[0]);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.video}
                      </span>
                    </div>
                  </div> */}

                  <div className="row ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Cost</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="cost"
                        placeholder="230 $"
                        value={price}
                        onChange={(event) => {
                          setPrice(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.price}
                      </span>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Tax</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="tax"
                        placeholder="230 $"
                        value={tax}
                        onChange={(event) => {
                          setTax(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.tax}
                      </span>
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-4 d-flex justify-content-center aligns-items-center">
                      {/* <Link to={`/superstar/post/${params.id}`}>
                      <button className="btn btnGoBack fw-bold" type="submit">
                        Go Back
                      </button>
                    </Link> */}
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SouvenirEditStar;
